// @flow
import MessagesContainer from './containers/MessagesContainer';

export default MessagesContainer;